import { render, staticRenderFns } from "./EditUiCard.vue?vue&type=template&id=5d8ad534"
import script from "./EditUiCard.vue?vue&type=script&lang=ts"
export * from "./EditUiCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports